import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MultiSelectPopoverComponent } from '../multi-select-popover/multi-select-popover.component';
import { TRenderOptionType, TMultiSelectFilterGroupInfo } from '../filter/model/ui-filter.types';
import { ModalController, PopoverController } from '@ionic/angular';
import { createThrottler } from '@monorepo/utils';

@Component({
  selector: 'monorepo-inline-multi-select',
  templateUrl: './inline-multi-select.component.html',
  styleUrls: ['./inline-multi-select.component.scss'],
})
export class InlineMultiSelectComponent {
  @Input() inlineMultiSelectInput!: TMultiSelectFilterGroupInfo;
  @Input() popoverRenderOptionType: TRenderOptionType = 'MODAL';
  @Output() selectedItemsEvent = new EventEmitter<TMultiSelectFilterGroupInfo>();
  #throttle = createThrottler();

  constructor(public popoverController: PopoverController, private modalController: ModalController) {}

  onSelection(data: TMultiSelectFilterGroupInfo['items']) {
    const selectedItems = data
      .filter((option) => option.isSelected)
      .map((option) => {
        return {
          value: option.value,
          displayName: option.displayName,
        };
      });
    const multiSelectData = {
      ...this.inlineMultiSelectInput,
      items: data,
      selectedValues: selectedItems,
    };
    this.selectedItemsEvent.emit(multiSelectData);
  }

  async presentPopover(ev: Event) {
    switch (this.popoverRenderOptionType) {
      case 'INLINE':
        this.#throttle('popover', () => this.createPopover(ev, 'multi-select-popover-inline'), 1000);
        break;
      case 'MODAL':
        this.#throttle('modal', () => this.createModal('multi-select-popover-component-modal'), 1000);
        break;
    }
  }

  async createModal(cssClass: string) {
    const modal = await this.modalController.create({
      component: MultiSelectPopoverComponent,
      cssClass,
      componentProps: {
        popoverInfo: this.inlineMultiSelectInput.items,
        popoverRenderOptionType: this.popoverRenderOptionType,
        virtualScroll: this.inlineMultiSelectInput.virtualScroll,
        preTagForDataDisplay: this.inlineMultiSelectInput.preTagForDataDisplay,
      },
    });
    await modal.present();
    const dismissVal = await modal.onDidDismiss();
    const dimissData = dismissVal.data as TMultiSelectFilterGroupInfo['items'];
    if (dimissData) this.onSelection(dimissData);
  }

  async createPopover(ev: Event, cssClass: string) {
    console.log('this.inlineMultiSelectInput.virtualScroll', this.inlineMultiSelectInput.virtualScroll);
    const popover = await this.popoverController.create({
      component: MultiSelectPopoverComponent,
      event: ev,
      cssClass,
      animated: false,
      componentProps: {
        popoverInfo: this.inlineMultiSelectInput.items,
        popoverRenderOptionType: this.popoverRenderOptionType,
        virtualScroll: this.inlineMultiSelectInput.virtualScroll,
        preTagForDataDisplay: this.inlineMultiSelectInput.preTagForDataDisplay,
      },
      translucent: true,
    });
    await popover.present();
    const dismissVal = await popover.onDidDismiss();
    const dimissData = dismissVal.data as TMultiSelectFilterGroupInfo['items'];
    if (dimissData) this.onSelection(dimissData);
  }
}
